/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

export enum ExportMultiOrderType {
    PAYMENT_ORDER = 'PAYMENT_ORDER',
    BUNDLE = 'BUNDLE',
    BULK = 'BULK',
    DATACARRIER = 'DATACARRIER',
    STANDING_ORDER = 'STANDING_ORDER',
    SWEEP_ORDER = 'SWEEP_ORDER',
}
